/* eslint-disable no-param-reassign -- RTK createSlice uses Immer; mutating state is correct */
import { createSlice } from '@reduxjs/toolkit';

const POLL_INTERVAL = 4000;
const MAX_POLL_ATTEMPTS = 5;

const findemSyncSlice = createSlice({
  name: 'findemSync',
  initialState: {
    expectedCountDelta: 0,
    baseCount: null,
    polling: false,
    attempts: 0,
  },
  reducers: {
    listCreated: (state) => {
      state.expectedCountDelta += 1;
      state.polling = true;
      state.attempts = 0;
    },
    listDeleted: (state) => {
      state.expectedCountDelta -= 1;
      state.polling = true;
      state.attempts = 0;
    },
    setBaseCount: (state, action) => {
      state.baseCount = action.payload;
    },
    syncComplete: (state) => {
      state.expectedCountDelta = 0;
      state.baseCount = null;
      state.polling = false;
      state.attempts = 0;
    },
    incrementAttempts: (state) => {
      state.attempts += 1;
      if (state.attempts >= MAX_POLL_ATTEMPTS) {
        state.expectedCountDelta = 0;
        state.baseCount = null;
        state.polling = false;
        state.attempts = 0;
      }
    },
  },
});

export const { listCreated, listDeleted, setBaseCount, syncComplete, incrementAttempts } = findemSyncSlice.actions;

export const selectIsPolling = (state) => state.findemSync.polling;
export const selectExpectedCountDelta = (state) => state.findemSync.expectedCountDelta;
export const selectBaseCount = (state) => state.findemSync.baseCount;

export { POLL_INTERVAL, MAX_POLL_ATTEMPTS };

export default findemSyncSlice.reducer;
